/**
 * 폼 컨트롤(BaseField·BaseSelect) 공통 스타일 SSoT.
 * components.css .field/.input/.select 패턴을 단일 출처로 모아 두 컴포넌트가 공유한다
 * (입력·셀렉트의 라벨·메시지·보더·포커스 스타일이 동일 — 복붙 시 드리프트 방지).
 *
 * 컨트롤 base 는 padding 을 뺀 공통 골격이다 — input/select 가 각자 padding 유틸을
 * 덧붙인다(input: px-[14px], select: pl-[14px] pr-10 + appearance-none).
 */

/** 라벨(.field label) — 필수표시 span 은 각 컴포넌트가 별도 처리. */
export const FIELD_LABEL_CLASS =
  'mb-[7px] block text-[12.5px] font-bold tracking-[-0.01em] text-brand';

/** 컨트롤 공통 골격(padding 제외) — input/select 가 padding 을 덧붙인다. */
export const FIELD_CONTROL_BASE_CLASS =
  'w-full rounded-field border border-line bg-white font-sans text-[14.5px] text-ink outline-none transition-[border-color] focus:border-accent disabled:opacity-50';

/** is-error 시 보더(공통 보더 위에 cn 으로 병합). */
export const FIELD_CONTROL_ERROR_CLASS = 'border-danger focus:border-danger';

/** 에러 메시지(.field .err). */
export const FIELD_ERROR_MSG_CLASS = 'mt-1.5 text-[11.5px] leading-[1.5] text-danger';

/** 보조 안내 메시지(.field .hint). */
export const FIELD_HINT_MSG_CLASS = 'mt-1.5 text-[11.5px] leading-[1.5] text-muted';
